module.exports = "https://s.pinimg.com/webapp/style/images/RO@2x-0ac04c26.png";